import React from 'react';
import styled from 'styled-components';
import { getContrastColor, Icons } from '@wingscms/crane';
import { ShareTitle } from './DefaultText';
var Facebook = Icons.Facebook,
    Twitter = Icons.Twitter,
    Whatsapp = Icons.Whatsapp,
    Email = Icons.Email;
var ShareContainer = styled.div.withConfig({
  displayName: "ShareButtons__ShareContainer",
  componentId: "sc-1358fc5-0"
})(["padding-top:20px;position:relative;display:block;text-align:center;width:100%;"]);
var ShareButton = styled.a.withConfig({
  displayName: "ShareButtons__ShareButton",
  componentId: "sc-1358fc5-1"
})(["display:inline-block;vertical-align:middle;height:40px;width:40px;background-color:", ";border-radius:4px;position:relative;margin:0 5px;transition:all 0.2s linear;padding:12px;svg{display:block;fill:", ";}&:hover{background-color:", ";svg{fill:", ";}}@media screen and (min-width:800px){height:50px;width:50px;img{margin:15px auto;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getContrastColor({
    backgroundColor: theme.primaryColor,
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.secondaryColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return getContrastColor({
    backgroundColor: theme.secondaryColor,
    colors: {
      light: theme.textColor,
      dark: theme.textColorDark
    },
    threshold: theme.contrastLuminanceThreshold
  });
});
export default (function (props) {
  var _props$pageContext = props.pageContext,
      shareUrls = _props$pageContext.shareUrls,
      resourceType = _props$pageContext.node.resourceType;
  return React.createElement(ShareContainer, null, React.createElement(ShareTitle, {
    resourceType: resourceType
  }), React.createElement(ShareButton, {
    href: shareUrls.facebook,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Facebook, null)), React.createElement(ShareButton, {
    href: shareUrls.twitter,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Twitter, null)), React.createElement(ShareButton, {
    href: shareUrls.whatsapp,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Whatsapp, null)), React.createElement(ShareButton, {
    href: shareUrls.email
  }, React.createElement(Email, null)));
});